import { Component, OnInit, Input } from '@angular/core';
import { NgxCurrencyInputMode } from 'ngx-currency';
import moment from 'moment';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//Services
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { EmployeeInfoService } from 'src/app/core/services/employee-info.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { FieldService } from 'src/app/pages/field/service/field.service';
import { AdminService } from 'src/app/pages/admin/services/admin.service';

@Component({
  selector: 'app-review-onboarding-modal',
  templateUrl: './review-onboarding-modal.component.html',
  styleUrls: ['./review-onboarding-modal.component.css'],
})
export class ReviewOnboardingModalComponent implements OnInit {
  @Input() employee: any;
  portalSettings: any;
  format: string;
  employeeInfo: any;
  onAdmin: any;
  initMode = false;
  formData: { [key: string]: any } = {};
  newFiles: any[] = [];
  savedFiles: any[] = [];
  deleteMode = false;
  taskDeleted = false;
  currencySymbol: string;
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
    adaptivePosition: boolean;
  };
  existingMsg: string;
  raceList: any[] = [];
  timeRevList: any[] = [];
  insuranceCodeList: any[] = [];
  prCompanies: any[] = [];
  tasks: any[] = [];
  fileData: any[] = [];
  innerCounter: number;
  errorMsg: string;
  hrCompanies: any[] = [];
  pRGroups: any[] = [];
  crafts: any[] = [];
  classes: any[] = [];
  departments: any[] = [];
  earnCodes: any[] = [];
  processed = false;
  processing = false;
  alert: any;
  options: { [key: string]: any } = {};
  validComboDrag: any;
  dragFiles: any;
  mobileMode = false;

  constructor(
    private portalSettingsService: PortalSettingsService,
    private utilityService: UtilityService,
    private employeeInfoServcie: EmployeeInfoService,
    private hiringService: HiringService,
    private fieldService: FieldService,
    private employeeService: EmployeeService,
    private adminService: AdminService,
    private httpClient: HttpClient,
    private activeModal: NgbActiveModal
  ) {
    this.portalSettings = this.portalSettingsService.getPortalSettings();
    this.format = this.utilityService.getDateFormat().toUpperCase();
    this.employeeInfo = this.employeeInfoServcie.getEmployeeInfo();
  }
  ngOnInit(): void {
    this.mobileMode = this.utilityService.isMobileMode();
    this.onAdmin = this.employeeInfo.IsOnboardAdmin;
    this.currencySymbol = '$';
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);
    this.formData.Gender = this.employee.gender == 'Male' ? 'M' : this.employee.gender == 'Female' ? 'F' : null;
    this.datePickerOptions = {
      dateInputFormat: this.format,
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
      adaptivePosition: true,
    };
    if (this.employee.TasksCompleted != 'In Process' && this.employee.TasksCompleted != 'Completed') this.getTasks();
    this.getHRCo();
    this.getPRCo();
    this.getAttachmentList();
    if (this.employee.hasOwnProperty('existingHire')) {
      if (this.employee.existingHire[0]) {
        this.existingMsg = 'It appears this employee is a re-hire - an existing HR Resource has been found with the same SSN.';
      }
    }
    this.getRaceCodes();
    this.getTimeRevGroup();
  }

  checkMaxLength() {
    if (this.formData.hrRef.toString().length > 6) this.formData.hrRefDisable = true;
    else this.formData.hrRefDisable = false;
  }

  pRCoChanged() {
    this.formData.PRGroup = null;
    this.formData.Craft = null;
    this.formData.Class = null;
    this.formData.PRDept = null;
    this.formData.EarnCode = null;
    this.formData.InsCode = null;
    this.getPRGroup();
    this.getCraft();
    this.getPRDept();
    this.getEarnCode();
    this.getInsuranceCode();
  }

  craftChanged() {
    this.formData.Class = null;
    this.getClass();
  }

  getRaceCodes() {
    this.hiringService.getRaceCodes().then((response: any[]) => {
      if (response != null) {
        this.raceList = response;
        if (this.employee.raceEthnicity != null) {
          this.raceList.forEach((val: any) => {
            if (val.Description.substr(0, 4).toLowerCase().indexOf(this.employee.raceEthnicity.substr(0, 4).toLowerCase()) > -1) {
              this.formData.Race = val.Race;
            }
          });
        }
      }
    });
  }

  getTimeRevGroup() {
    this.hiringService.getTimeRevGroup().then((response: any[]) => {
      if (response != null) {
        this.timeRevList = response;
      }
    });
  }

  getInsuranceCode() {
    this.hiringService.getInsCodes().then((response: any[]) => {
      if (response != null) {
        this.insuranceCodeList = response;
      }
    });
  }

  hrcoUpdate() {
    if (this.formData.PRCo == null && this.prCompanies != null) {
      this.prCompanies.forEach((val: any) => {
        if (this.formData.HRCo.CompanyName == val.PRCoNameMask) {
          this.formData.PRCo = val.PRCo;
          this.pRCoChanged();
          return false;
        }
      });
    }
  }

  getTasks() {
    this.hiringService.getTasksByOnboardID(this.employee.OnboardID).then((response: any[]) => {
      if (response != null) {
        var tasks = response;
        for (var i = 0; i < response.length; i++) {
          var task = tasks[i];
          task.TaskCompletedDisplay = null;
          if (task.OnboardTaskDateCompleted != null) {
            task.TaskCompletedDisplay = moment.utc(task.OnboardTaskDateCompleted).format(this.format.toUpperCase());
          }
          if (task.OnboardTaskDateCompleted != null)
            task.Filename =
              task.OnboardTaskName.replace(/[^0-9a-zA-z]/g, ' ') +
              '_' +
              moment.utc(task.OnboardTaskDateCompleted).format('l').replace(/\//g, '_') +
              '.pdf';
          else task.Filename = task.OnboardTaskName.replace(/[^0-9a-zA-z]/g, ' ');
        }
        this.tasks = tasks;
      }
    });
  }

  downloadDocument(task: any) {
    return (
      '/Employee/DownloadDocument?onboardID=' +
      task.OnboardID +
      '&bulletinID=' +
      task.OnboardBulletinID +
      '&filename=' +
      encodeURIComponent(task.Filename)
    );
  }

  downloadChecklist(task: any) {
    return (
      '/Checklist/DownloadChecklists?checklistInstanceIDs=' +
      task.OnboardChecklistInstanceID +
      '&filenames=' +
      encodeURIComponent(task.Filename) +
      '&templateID=' +
      task.ChecklistTemplateID +
      '&isonboard=true'
    );
  }

  getAttachmentList() {
    this.newFiles = [];
    this.fieldService
      .getDBAttachmentList(60, null, this.employee.OnboardID, null)
      .then((response: any[]) => {
        if (response != null) {
          this.savedFiles = response;
        }
      })
      .catch((error: any) => {
        this.alert = { type: 'danger', msg: error?.error?.error ?? 'An error has occured' };
        this.processing = false;
      });
  }

  deleteAttachment(data: any) {
    this.employeeService
      .removeFileAttachment(data.FileAttachmentID)
      .then((response: any) => {
        if (response != null) {
          this.getAttachmentList();
        }
      })
      .catch((error: any) => {
        this.alert = { type: 'danger', msg: error?.error?.error ?? 'An error has occured' };
        this.processing = false;
      });
  }

  readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  upload() {
    this.newFiles = [];
    this.fileData = [];
    this.innerCounter = 0;
    for (var i = 0; i < this.formData.fileDrop.length; i++) {
      this.formData.fileDrop[i].nameEdit = this.utilityService.formatAttachmentName(this.formData.fileDrop[i].name);
      var n = 0;
      this.readFile(this.formData.fileDrop[i], (e: any, fileName: string) => {
        setTimeout(() => {
          this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
          if (n == this.formData.fileDrop.length - 1) {
            this.fileData.forEach((val: any) => {
              this.formData.fileDrop.forEach((val2: any) => {
                if (val2.size == val.size && val.name == val2.name) {
                  this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split('/')[0] });
                }
              });
            });
            if (this.formData.fileDrop && this.formData.fileDrop.length >= 1) {
              this.newFiles.forEach((val3: any) => {
                if (val3.Progress != 100 && val3.File != null) {
                  var temp = val3.Type;
                  var type = 'file';
                  if (temp == 'data:image') type = 'Photo';
                  this.httpClient
                    .request(
                      new HttpRequest(
                        'POST',
                        '/Document/SaveDBAttachment',
                        {
                          moduleID: 60,
                          recordGUID: this.employee.OnboardID,
                          attachmentFileData: val3.File,
                          attachmentFileName: val3.Filename,
                          recordID: -1,
                        },
                        { reportProgress: true }
                      )
                    )
                    .subscribe(
                      (event: HttpEvent<any>) => {
                        switch (event.type) {
                          case HttpEventType.UploadProgress:
                            val3.Progress = Math.round((event.loaded / event.total) * 100);
                            if (val3.Progress == 100) {
                              val3.AttchDone = true;
                            }
                            break;
                          case HttpEventType.Response:
                            this.innerCounter++;
                            this.innerCounterChange();
                            val3.Filedata.result = event.body;
                        }
                      },
                      error => (this.errorMsg = error.message)
                    );
                }
              });
            }
          }
          n++;
        });
      });
    }
  }

  innerCounterChange() {
    if (this.innerCounter == this.newFiles.length && this.innerCounter != 0) {
      this.getAttachmentList();
      this.formData.fileDrop = null;
    }
  }

  getHRCo() {
    this.hiringService.getHRCO().then((response: any[]) => {
      if (response != null) {
        this.hrCompanies = response;
      }
    });
  }

  getPRCo() {
    this.adminService.getCompanies().then((response: any[]) => {
      if (response != null) {
        this.prCompanies = response;
      }
    });
  }

  getPRGroup() {
    this.hiringService.getCompanyGroups(this.formData.PRCo).then((response: any[]) => {
      if (response != null) {
        this.pRGroups = response;
      }
    });
  }

  getCraft() {
    this.hiringService.getCraft(this.formData.PRCo).then((response: any[]) => {
      if (response != null) {
        this.crafts = response;
      }
    });
  }

  getClass() {
    this.hiringService.getClass(this.formData.PRCo, this.formData.Craft).then((response: any[]) => {
      if (response != null) {
        this.classes = response;
      }
    });
  }

  getPRDept() {
    this.hiringService.getPRDept(this.formData.PRCo).then((response: any[]) => {
      if (response != null) {
        this.departments = response;
      }
    });
  }

  getEarnCode() {
    this.hiringService.getEarnCode(this.formData.PRCo).then((response: any[]) => {
      if (response != null) {
        this.earnCodes = response;
      }
    });
  }

  deleteTask(task: any) {
    task.ConfirmDelete = true;
  }

  confirmDeleteTask(task: any) {
    this.hiringService.deleteTask(task.OnboardTaskID).then((response: any) => {
      if (response != null && response.success) {
        this.taskDeleted = true;
        this.tasks.splice(this.tasks.indexOf(task), 1);
      }
    });
  }

  confirmDelete() {
    this.processing = true;
    this.hiringService.deleteOnboarding(this.employee.OnboardID).then((response: any) => {
      if (response != null && response.success) {
        this.activeModal.close({ alert: { type: 'success', msg: 'Onboarding instance has been deleted.' } });
        this.processed = true;
        this.processing = false;
      } else {
        this.alert = { type: 'danger', msg: response.data.errorMessage };
        this.processing = false;
      }
    });
  }

  closeClicked() {
    if (this.taskDeleted) this.activeModal.close({ action: 'taskRebind' });
    else this.activeModal.dismiss();
  }

  sendReminder() {
    this.hiringService.sendReminder(this.employee.OnboardID).then((response: any) => {
      if (response != null && response.success) {
        this.alert = { type: 'success', msg: 'Email reminder sent' };
      }
    });
  }

  toggleInitialize() {
    this.formData.HRCo = null;
    this.formData.PRCo = null;
    this.formData.PRGroup = null;
    this.formData.Craft = null;
    this.formData.Class = null;
    this.formData.PRDept = null;
    this.formData.EarnCode = null;
    this.formData.hireDate = new Date();
    this.initMode = !this.initMode;
  }

  autoRefChange() {
    if (this.formData.autoRef) this.formData.hrRef = null;
  }

  initializeBirdDog() {
    var requestObj = {
      effectiveHireDateStr: null,
      hRCoForInitialization: null,
      pRCo: null,
      pRGroup: null,
      wage: null,
      craft: null,
      classID: null,
      pRDept: null,
      earnCode: null,
      email: null,
      gender: null,
      raceEthnicity: null,
      insuranceCode: null,
      hRRef: null,
      timesheetRevGroup: null,
      TasksCompleted: null,
      systemID: null,
    };
    if (this.employee.OnboardID == null) {
      for (const [key, val] of Object.entries(this.employee)) {
        requestObj[key] = val;
      }
    }
    requestObj.effectiveHireDateStr = moment(this.formData.hireDate).format('MM/DD/YYYY');
    requestObj.hRCoForInitialization = this.formData.HRCo.HRCo;
    if (this.formData.PRCo !== null) {
      requestObj.pRCo = this.formData.PRCo;
    }
    if (this.formData.PRGroup !== null) {
      requestObj.pRGroup = this.formData.PRGroup;
    }
    if (this.formData.Wage !== null) {
      requestObj.wage = this.formData.Wage;
    }
    if (this.formData.Craft !== null) {
      requestObj.craft = this.formData.Craft;
    }
    if (this.formData.Class !== null) {
      requestObj.classID = this.formData.Class;
    }
    if (this.formData.PRDept !== null) {
      requestObj.pRDept = parseInt(this.formData.PRDept);
    }
    if (this.formData.EarnCode !== null) {
      requestObj.earnCode = this.formData.EarnCode;
    }
    if (this.employee.Email !== null) {
      requestObj.email = this.employee.Email;
    }
    if (this.formData.Gender != null) {
      requestObj.gender = this.formData.Gender;
    }
    if (this.formData.Race !== null) {
      requestObj.raceEthnicity = this.formData.Race;
    }
    if (this.formData.InsCode !== null) {
      requestObj.insuranceCode = this.formData.InsCode;
    }
    if (this.formData.hrRef !== null) {
      requestObj.hRRef = this.formData.hrRef;
    }
    if (this.formData.timesheetRevGroup !== null) {
      requestObj.timesheetRevGroup = this.formData.timesheetRevGroup;
    }
    requestObj.TasksCompleted = this.employee.TasksCompleted;
    this.processing = true;
    this.hiringService.onInitializeBirdDogRecord(requestObj).then((response: any) => {
      if (response != null) {
        if (response.success) {
          this.activeModal.close({
            alert: {
              type: 'success',
              msg:
                this.employee.FirstName +
                ' ' +
                this.employee.LastName +
                ' has been successfully initialized to Company ' +
                this.formData.HRCo.HRCo +
                ' as HRRef ' +
                response.result.NewHRRef +
                '.',
            },
          });
          this.processed = true;
          this.processing = false;
        } else {
          this.alert = { type: 'danger', msg: response.errorMessage };
          this.processing = false;
        }
      }
    });
  }

  closeAlert() {
    this.alert = null;
  }
}
